import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row h-vh" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 col-12 p-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-r" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row w-100" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }),
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-md-8 login100-pic js-tilt",
        "data-tilt": ""
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "login-img text-center" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" })
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, null, -1)
const _hoisted_6 = { class: "col-md-5 login-s" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _hoisted_7
      ])
    ])
  ]))
}